// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PostMetadata_wrapper__2qfzW","timestamp":"PostMetadata_timestamp__1nvlM"};